module.exports = __webpack_public_path__ + "img/logo-talleres.fe26f9ea.png";